import { Button } from "PFComponents/button";
import { Tooltip } from "PFComponents/tooltip";
import { useTranslation } from "react-i18next";

type EditSingleButtonProps = { onClick: VoidFunction; disabled?: boolean };

export const EditSingleButton = ({ onClick, disabled }: EditSingleButtonProps) => {
  const { t } = useTranslation("bookingModule");
  return (
    <Tooltip content={t("bookings.update.editAction")}>
      {({ ref, getReferenceProps }) => (
        <Button
          ref={ref}
          icon="edit"
          kind="secondary"
          {...getReferenceProps({ onClick, title: t("bookings.update.editBooking"), disabled })}
        />
      )}
    </Tooltip>
  );
};
